/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./customForm.vue?vue&type=template&id=41d77c05&scoped=true&"
import script from "./customForm.vue?vue&type=script&lang=js&"
export * from "./customForm.vue?vue&type=script&lang=js&"
import style0 from "./customForm.vue?vue&type=style&index=0&id=41d77c05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d77c05",
  null
  
)

export default component.exports